import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'signed-out',
    component: () => import('./SignedOutView.vue'),
    meta: { title: 'Signed out', public: true },
  },
]
